import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button as AntdButton, List as AntdList, Spin } from 'antd';

import useDownloadFile from 'hooks/api/useDownloadFile';
import { useApi } from 'hooks/ApiStoreContext';
import {
  DownloadableFileMetaData,
  DownloadableFileStatus,
} from 'hooks/DownloadableFilesContext';

import FileStatusIcon from './FileStatusIcon';

import './DownloadableFileItem.less';

const DownloadableFileItem = ({
  file,
}: {
  file: DownloadableFileMetaData;
}): React.ReactElement => {
  const exportApi = useApi().ExportControllerApi;
  const fetchFile = () => exportApi.downloadExportUsingGET(file.id);

  const { mutate: download, isPending } = useDownloadFile(file.name, fetchFile);

  return (
    <AntdList.Item className="FileItem">
      <FileStatusIcon file={file} />
      <div className="FileItemMainArea">
        <h5 className="FileItemTitle">{file.name}</h5>
        <div className="FileItemDetail">{file.detail}</div>
        {file.requestDate && (
          <div className="FileItemDate">Créé {file.requestDate}.</div>
        )}
        {file.expirationDate && (
          <div className="FileItemDate">
            Ce fichier expirera {file.expirationDate}.
          </div>
        )}
      </div>

      {file.status === DownloadableFileStatus.SUCCESS && (
        <AntdButton
          icon={isPending ? <Spin /> : <DownloadOutlined />}
          type={'default'}
          shape={'round'}
          onClick={download}
        />
      )}
    </AntdList.Item>
  );
};

export default DownloadableFileItem;
